import type { FaireProductEntity } from "../../entity_types/product";

export const p_wgvhps7fwj: FaireProductEntity = {
  token: "p_wgvhps7fwj",
  type: "product",
  name: "Swing Socks (Wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/fc2158dfbee1f4d09187ea04c4275845aa552f4a7bf926e2696d1deb8532db19.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9d4634d918bd39c67634ec9595ad09a39de9cf1e9a8ad0878f3af40e29d3caf8.jpeg",
    "https://cdn.faire.com/fastly/0a7d641d4b7894e73c463bd44cc8e8667000e85ad669036ca9639b2e4e7ed4a5.jpeg",
    "https://cdn.faire.com/fastly/e0bc7d80192e179d45a7068dc12b51660111b86aee880a1924edf5f1114041ac.jpeg",
    "https://cdn.faire.com/fastly/68fc759b5f1c19b006d5a59ceda14be6938d1bc9546f2a3b0838b4686dec4370.jpeg",
    "https://cdn.faire.com/fastly/3398b3caf0b4b66330a49542ebc52ef117b2320421d80d6100bb22c498e8b4ec.jpeg",
    "https://cdn.faire.com/fastly/0f0682de1cd5d2861c2b577bbd64d21c17110bcfae5b0134be884bc2c5658663.jpeg",
    "https://cdn.faire.com/fastly/500b1213808b7b3a05164b2d6fa763d07ca8129df090a4c33b9bd13ee02e82d9.jpeg",
    "https://cdn.faire.com/fastly/dfd7956c2ea0982bd79f46f39d887f036eff63b5a5cc7a7f181635e1efb0401c.jpeg",
    "https://cdn.faire.com/fastly/cee14c20a85dda0aed8612c1a51b28e82bc8876a7b580c6754b42f82e191629d.jpeg",
    "https://cdn.faire.com/fastly/0a15c47cfcbec3c0e391d48ddeb8f71c5d53aeb79bf634454eab4aa7e29926b5.jpeg",
    "https://cdn.faire.com/fastly/2580b9d6fda87d6c56565e93dc8d48b283a12d201d4c286db6186b794833672e.jpeg",
    "https://cdn.faire.com/fastly/500c0d795a2e2cb64d4ec9e68512d0d765cc7f7ef963d0c790abad22fd77fc20.jpeg",
    "https://cdn.faire.com/fastly/10413e563ebb9075a88114ee48d0fd16758419df0183560589a88c376e2054c7.jpeg",
    "https://cdn.faire.com/fastly/b9502cdf33b54255c4c25cebbd39e6a13ac5594cbffbb89b4497c4697c26b978.jpeg",
    "https://cdn.faire.com/fastly/e797351babbf2437cdcfc8e19917cca0af62f5d0d9f184ef75d0513f722c253f.jpeg",
    "https://cdn.faire.com/fastly/6049d089edd8ee985ff91eebf499354d10ae8202a7c9f388f7e61acdfcbf6b06.jpeg",
    "https://cdn.faire.com/fastly/80eaacf9b356c2c0a309247661f5a1216c3536dc1fb70ffa57c86d5f780f440c.jpeg",
    "https://cdn.faire.com/fastly/b3747ea783614e03b26075b74fdeb239a9a14c579389f731623e96d904e39241.jpeg",
    "https://cdn.faire.com/fastly/deee54125e0ce6a959a04b5d1f246445dac953c22c09833cc48be757f4893b9d.jpeg",
    "https://cdn.faire.com/fastly/346418475f1c312bc04dabee8e1086467ca50771bbd9c9bcf4a82c26eced794e.jpeg",
    "https://cdn.faire.com/fastly/87e75957b703ba78f035f023c71536ac6c4fe87388c9caabc7569bfca251f57f.jpeg",
    "https://cdn.faire.com/fastly/8ddb3d8ba306c093b02818b1f559cbcbca1cc085cb421656580a55474074a97f.jpeg",
    "https://cdn.faire.com/fastly/8c1852217663bb4ea787a43ec4ac0875df0626665d1229afe89c305a590c1a56.jpeg",
    "https://cdn.faire.com/fastly/0dc24d167abf29bea2c3b5e8dff856c9d211c55cfbe2fc69c37160099dbd2b03.jpeg",
    "https://cdn.faire.com/fastly/506cf08f2c955e92cefe244da18786e1cf64c622301c66d8a013276297e912fb.jpeg",
    "https://cdn.faire.com/fastly/b79b94a3b494ef75789e9759c56df6bac353000612c2e613a22077d78dd13c10.jpeg",
  ],
  priceDollars: 6,
  description:
    "Why We Made This?\n\nSay hello to the Swing Socks, a shorter version of the Ballet Socks with the same Girlfriend feel to them. This fun style features a thicker ribbed leg for that bubble, cushioned texture while still maintaining a classic crew length. Pair them with sneakers for a casual look, or dress them up with Mary Jane's.\n\n\n\n\nMade in South Korea\n\n\n\n\nContents: \n\n85 Cotton 13 Polyester 2 Spdx\n\n\n\n\nSizing:\n\nOne size fits most (US women's size 6-10)\n\n\n\n\nCare Instructions:\n\nMachine wash cold\n\nTumble dry low\n\nDo not iron\n\nDo not bleach\n\n\n\n***Order in units of 6 (6,12,18,24 etc)\n\n\n\n\nMSRP: $15 USD\n",
  tags: [],
  msrpDollars: 15,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:03.005Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
